import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const TableWrapper = styled.div`
width: 100%;
`;

const HeaderRow = styled.div`
display: grid;
grid-template-columns: ${({columns}) => columns ? columns : '2fr 1fr 1.5fr 1.5fr 40px'};
margin: 20px 0;
  padding: 10px 12px;

  border-radius: 6px;
  border: 1px solid #efefef;
  background: #fefefe;

  color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
`;

const Row = styled.div`
display: grid;
grid-template-columns: ${({columns}) => columns ? columns : '2fr 1fr 1.5fr 1.5fr 40px'};
align-items: center;

margin: 20px 0;
padding: 16px 20px;

border-radius: 6px;
border: 1px solid #efefef;
background: #fff;
`;

const Cell = styled.div`
font-family: Lato;
font-size: 16px;
color: #184A61;
text-align: ${({ align }) => align || "center"}; 
`;

const NoData = styled.div`
padding: 40px;
text-align: center;
color: #7C7C7C;
`;

const CommonListView = ({ headers, data, renderCell, grid }) => {

  if (!data?.length) {
    return <NoData>No Data Available</NoData>;
  }

  return (
    <TableWrapper>

      <HeaderRow columns={grid}>
        {headers.map((header, i) => (
          <Cell align={header.align} key={i}>{header.label}</Cell>
        ))}
      </HeaderRow>

      {data.map((row, index) => (
        <Row key={index} columns={grid}>
          {headers.map((header, i) => (
            <Cell key={i}>
              {renderCell(header.key, row)}
            </Cell>
          ))}
        </Row>
      ))}

    </TableWrapper>
  );
};

CommonListView.propTypes = {
  headers: PropTypes.array,
  data: PropTypes.array,
  renderCell: PropTypes.func,
  grid: PropTypes.string,
};
  

export default CommonListView;